export const PAYMENT_LINK = "https://rzp.io/rzp/webinarregistration9";
export const LOGO_URL =
    "https://customer-assets-eiarnc6j.emergentagent.net/job_future-work-ai-7/artifacts/edkppzxr_Suhaniedge%20logo%20in%201%20ratio%201.jpeg";
export const MENTOR_PHOTO =
    "https://customer-assets-eiarnc6j.emergentagent.net/job_future-work-ai-7/artifacts/5tpifpfu_image-1.jpeg";
export const HERO_VIDEO_ID = "mxqDVpum6eI";
export const SHORT_IDS = [
    "95DdnZIahVs",
    "S89xpEC0pmA",
    "SEI6R58Sp9M",
    "FaWB9N5IBCo",
    "hQlFtVJQsSM",
    "pbqAx3w2hHI",
];

export const SOCIALS = {
    instagram: "https://www.instagram.com/suhaniedge",
    youtube: "https://youtube.com/@suhaniedge",
    linkedin: "https://www.linkedin.com/in/suhanisingh10",
    pinterest: "https://pin.it/2RocXzzxL",
    email: "hello@suhaniedge.com",
    website: "https://suhaniedge.com/",
};

export const BENEFITS = [
    { icon: "Brain", title: "WHAT TO LEARN", body: "Understand the AI skills and areas worth exploring." },
    { icon: "Laptop", title: "WHAT TO BUILD", body: "Discover practical projects you can create while learning." },
    { icon: "Package", title: "WHAT YOU CAN OFFER", body: "Understand how useful AI skills can become potential freelance services." },
    { icon: "Target", title: "WHAT TO SHOW", body: "Learn how projects can become the foundation of your portfolio." },
    { icon: "Handshake", title: "HOW FREELANCING WORKS", body: "Understand the basics of presenting your work and approaching potential clients." },
    { icon: "Compass", title: "WHAT TO DO NEXT", body: "Leave knowing the next step you can focus on." },
];

export const LEARNING = [
    { n: "01", title: "AI FREELANCING FOUNDATION", body: "Understand what AI freelancing actually means and how the journey works." },
    { n: "02", title: "AI SKILLS & TOOLS", body: "Explore practical AI skills, tools and workflows without trying to learn everything at once." },
    { n: "03", title: "PROJECT BUILDING", body: "Learn how to turn AI knowledge into useful, real-world projects." },
    { n: "04", title: "SERVICE CREATION", body: "Understand how skills can be packaged into clear freelance services." },
    { n: "05", title: "PORTFOLIO DIRECTION", body: "Understand what kind of work you can build and showcase." },
    { n: "06", title: "CLIENT OUTREACH", body: "Learn the fundamentals of presenting your work and approaching potential clients." },
    { n: "07", title: "REAL-WORLD AI APPLICATIONS", body: "See how AI can be applied across creative work, content, business workflows, automation and other practical use cases." },
];

export const ECOSYSTEM = [
    "Generative AI",
    "AI Automation",
    "AI Content Creation",
    "AI Marketing",
    "AI Filmmaking",
    "AI-Powered Business Solutions",
    "AI Assistants & Workflows",
    "And much more",
];

export const QUIZ = [
    {
        id: "suha_q1",
        label: "QUESTION 01",
        question: "WHERE ARE YOU RIGHT NOW WITH AI?",
        theme: "dark",
        options: [
            { key: "A", text: "I use ChatGPT, but I don't know what I can actually do with AI." },
            { key: "B", text: "I've tried AI tools, but I don't know what skill to focus on." },
            { key: "C", text: "I want to freelance with AI, but I don't know where to start." },
            { key: "D", text: "I know AI is important. I just need a clear direction." },
        ],
        cta: "THAT'S ME →",
    },
    {
        id: "suha_q2",
        label: "QUESTION 02",
        question: "WHAT WOULD YOU LIKE TO DO WITH AI?",
        theme: "light",
        options: [
            { key: "A", icon: "Laptop", text: "BUILD PROJECTS" },
            { key: "B", icon: "Settings", text: "SOLVE BUSINESS PROBLEMS" },
            { key: "C", icon: "Palette", text: "CREATE CONTENT & CREATIVE WORK" },
            { key: "D", icon: "TrendingUp", text: "OFFER AI SERVICES" },
            { key: "E", icon: "HelpCircle", text: "I'M NOT SURE YET" },
        ],
        cta: "THAT'S ME →",
    },
    {
        id: "suha_q3",
        label: "QUESTION 03",
        question: "WHAT WOULD YOU LOVE TO LEAVE THIS WEBINAR WITH?",
        theme: "dark",
        options: [
            { key: "A", icon: "Brain", text: "A BETTER UNDERSTANDING OF AI" },
            { key: "B", icon: "Compass", text: "A CLEAR LEARNING DIRECTION" },
            { key: "C", icon: "Laptop", text: "PRACTICAL PROJECT IDEAS" },
            { key: "D", icon: "Package", text: "A BETTER UNDERSTANDING OF AI FREELANCING" },
            { key: "E", icon: "Rocket", text: "ALL OF THE ABOVE" },
        ],
        cta: "SHOW ME THE ROADMAP →",
    },
];

export const SUHA_TIPS = [
    "Tap an answer — I'm listening!",
    "Nice choice. Keep going!",
    "I'm mapping your starting point...",
    "Almost there — one more!",
];

export const FLOW_STEPS = ["LEARN", "BUILD", "PACKAGE", "PRESENT", "START"];

export const ROADMAP = [
    { n: "01", title: "LEARN", body: "Understand what to learn and why." },
    { n: "02", title: "BUILD", body: "Create practical projects." },
    { n: "03", title: "PACKAGE", body: "Understand how useful skills can become services." },
    { n: "04", title: "PRESENT", body: "Learn how to communicate what you can do." },
    { n: "05", title: "START", body: "Understand the fundamentals of approaching potential clients." },
];

export const TRANSFORMATION = {
    from: [
        "Too many tools",
        "Too much information",
        "No clear skill",
        "Nothing to show",
        "Don't know what to offer",
        "Don't know where to start",
    ],
    to: [
        "A clearer learning path",
        "Practical project ideas",
        "Understanding of potential services",
        "Portfolio direction",
        "Client outreach fundamentals",
        "A clearer next step",
    ],
};

export const BONUSES = [
    {
        n: "BONUS #1",
        title: "AI FREELANCE BUILDER GPTs",
        body: "AI-powered assistants to help you work through different parts of your freelancing journey.",
        extra: "Ideas • Projects • Services • Portfolio • Outreach • Action Plans",
        extraLabel: "Use them for:",
        value: "₹999",
    },
    {
        n: "BONUS #2",
        title: "AI TOOLS & WORKFLOW GUIDE",
        body: "A simple starting guide to help you navigate the growing AI ecosystem without getting overwhelmed.",
        value: "₹599",
    },
    {
        n: "BONUS #3",
        title: "AI PROJECT IDEA LIBRARY",
        body: "Practical ideas to help you move from:",
        quote: ["“I want to learn AI.”", "“I want to build something.”"],
        value: "₹499",
    },
    {
        n: "BONUS #4",
        title: "AI FREELANCING STARTER KIT",
        body: "Practical resources to help you continue learning and taking action after the webinar.",
        value: "₹599",
    },
    {
        n: "BONUS #5",
        title: "FREELANCING ACTION CHECKLIST",
        body: "A simple checklist to help you move from:",
        quote: ["LEARN → BUILD → SHOW → START"],
        value: "₹301",
    },
];

export const BONUS_TOTAL = "₹2,997";

export const VALUE_STACK = [
    { name: "LIVE AI FREELANCING WEBINAR", value: "Live Access" },
    { name: "AI FREELANCE BUILDER GPTs", value: "₹999" },
    { name: "AI TOOLS & WORKFLOW GUIDE", value: "₹599" },
    { name: "AI PROJECT IDEA LIBRARY", value: "₹499" },
    { name: "AI FREELANCING STARTER KIT", value: "₹599" },
    { name: "FREELANCING ACTION CHECKLIST", value: "₹301" },
];

export const FAQS = [
    { q: "DO I NEED CODING KNOWLEDGE?", a: "No. The webinar is designed for beginners and starts with the fundamentals." },
    { q: "I'VE NEVER FREELANCED BEFORE. CAN I JOIN?", a: "Yes. Previous freelancing experience isn't required." },
    { q: "IS THIS ONLY ABOUT CHATGPT?", a: "No. The webinar covers the broader AI freelancing journey—skills, tools, projects, services, portfolio direction and client outreach." },
    { q: "WILL I LEARN EVERY AI TOOL?", a: "No. The goal isn't to overwhelm you with hundreds of tools. It's to help you understand what to learn, what to build and how to apply AI." },
    { q: "WILL I GET GUARANTEED CLIENTS OR INCOME?", a: "No. This is an educational webinar. Results depend on your skills, effort, execution, market and other factors." },
    { q: "WHAT DO I GET FOR ₹9?", a: "You receive access to the live AI freelancing webinar and the bonuses listed on this page." },
    { q: "IS THE WEBINAR LIVE?", a: "Yes." },
    { q: "WHAT HAPPENS AFTER I REGISTER?", a: "REGISTER → CONFIRMATION → WEBINAR DETAILS → JOIN LIVE" },
    {
        q: "IS THE 30-DAY AI FREELANCING CHALLENGE INCLUDED?",
        a: "No. The ₹9 webinar is the first step. The separate 30-Day AI Freelancing Challenge is introduced during the live webinar for people who want deeper guided implementation.",
    },
];

export const WHO_ITS_FOR = [
    "You're curious about AI.",
    "You've tried ChatGPT or other AI tools.",
    "You don't know which AI skill to focus on.",
    "You want to explore AI freelancing.",
    "You want practical direction.",
    "You're a student, creator, professional or aspiring freelancer.",
    "You're ready to learn and take action.",
];

export const REALITY_NOT = [
    "Guaranteed income",
    "Guaranteed clients",
    "Overnight success",
    "A magic freelancing formula",
    "Zero-effort results",
];

export const OBJECTION_NOT_NEED = [
    "Coding expertise",
    "A technical degree",
    "Previous freelancing experience",
    "Existing clients",
    "Knowledge of every AI tool",
];
